import { render, staticRenderFns } from "./side-menu.vue?vue&type=template&id=65cc4bda"
import script from "./side-menu.ts?vue&type=script&lang=js&external"
export * from "./side-menu.ts?vue&type=script&lang=js&external"
import style0 from "./side-menu.vue?vue&type=style&index=0&id=65cc4bda&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports